document.addEventListener('DOMContentLoaded', () => {
    window.scrollToDescription = () => {
        const descriptionTabs = document.querySelector('.station-tabs-tabset');
        if (descriptionTabs) {
            descriptionTabs.scrollIntoView({ behavior: 'smooth' });
        }
    };
});

(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
	});

	initProductAccordion();
	initZoomImage();
})();

//class FloatedForm extends HTMLElement {
//	constructor() {
//		super();
//		this.renderForm();
//	}

//	renderForm() {
//		fetch(this.getAttribute("data-product-url"))
//			.then((response) => response.text())
//			.then((responseText) => {
//				const responseHTML = new DOMParser().parseFromString(
//					responseText,
//					"text/html"
//				);
//				this.productElement = responseHTML.querySelector(
//					'div[id^="ProductInfo-"]'
//				);

//				this.preventDuplicatedIDs();
//				this.removeDOMElements();
//				this.setInnerHTML(this, this.productElement.innerHTML);

//				if (window.Shopify && Shopify.PaymentButton) {
//					Shopify.PaymentButton.init();
//				}

//				if (window.ProductModel) window.ProductModel.loadShopifyXR();

//				this.showMoreFields();
//			})
//			.finally(() => {
//				const selectDropDown = () => {
//					$(".product__popup .product-form__controls--dropdown").each(function () {
//						const elListItem = $(this).find(".dropdown-select ul li");
//						const elItem = $(this).find(".dropdown-select ul");
//						const selectedText = $(this).find(
//							".dropdown-select .select-label"
//						);

//						selectedText.on("click", function (e) {
//							elItem.toggleClass("active");
//							if (elItem.hasClass("active")) {
//								e.stopPropagation();
//								$(document).click(function () {
//									elItem.removeClass("active");
//								});
//							}
//						});

//						elListItem.on("click", function () {
//							selectedText
//								.find("span")
//								.text($(this).text())
//								.attr("title", $(this).text());
//							elItem.removeClass("active");
//							document.activeElement.blur();
//						});
//					});
//				};

//				selectDropDown();
//			});
//	}

//	setInnerHTML(element, html) {
//		element.innerHTML = html;

//		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//		element.querySelectorAll("script").forEach((oldScriptTag) => {
//			const newScriptTag = document.createElement("script");
//			Array.from(oldScriptTag.attributes).forEach((attribute) => {
//				newScriptTag.setAttribute(attribute.name, attribute.value);
//			});
//			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//		});
//	}

//	preventDuplicatedIDs() {
//		const sectionId = this.productElement.dataset.section;
//		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
//			sectionId,
//			`floated-${sectionId}`
//		);

//		if (this.productElement.querySelectorAll("variant-selects")) {
//			this.productElement
//				.querySelectorAll("variant-selects")
//				.forEach((radio) => {
//					radio.dataset.originalSection = sectionId;
//				});
//		}

//		if (this.productElement.querySelectorAll("variant-radios")) {
//			this.productElement
//				.querySelectorAll("variant-radios")
//				.forEach((radio) => {
//					radio.dataset.originalSection = sectionId;
//				});
//		}
//	}

//	removeDOMElements() {
//		const text = this.productElement.querySelector(".product__text");
//		if (text) text.remove();

//		const tags = this.productElement.querySelector(".product__tags");
//		if (tags) tags.remove();

//    const title = this.productElement.querySelector(".product__title__wrapper");
//		if (title) title.remove();

//		const badges = this.productElement.querySelector(".product__custom-badges");
//		if (badges) badges.remove();

//    const price = this.productElement.querySelector(".price-wrapper");
//		if (price) price.remove();

//		const description = this.productElement.querySelector(
//			".product__description"
//		);
//		if (description) description.remove();

//		const sku = this.productElement.querySelector(".product__sku");
//		if (sku) sku.remove();

//		const inventory = this.productElement.querySelector(".product__inventory");
//		if (inventory) inventory.remove();

//		const pickupAvailability = this.productElement.querySelector(
//			"pickup-availability"
//		);
//		if (pickupAvailability) pickupAvailability.remove();

//		const customLiquid = this.productElement.querySelector(".custom-liquid");
//		if (customLiquid) customLiquid.remove();

//		const complementary = this.productElement.querySelector(
//			"product-recommendations--single"
//		);
//		if (complementary) complementary.remove();

//		const shareButtons = this.productElement.querySelector(".share-buttons");
//		if (shareButtons) shareButtons.remove();

//		const productModal = this.productElement.querySelectorAll(".product-popup");
//		productModal.forEach((advantage) => {
//			advantage.remove();
//		});

//		const productForm = this.productElement.querySelector("floated-form");
//		if (productForm) productForm.remove();
//	}

//	showMoreFields() {
//		$(".js-show-more").click(function (e) {
//			e.preventDefault();
//			$(this).siblings("input").removeClass("hidden");
//			$(this).siblings("label").removeClass("hidden");
//			$(this).remove();
//		});
//	}
//}

//customElements.define("floated-form", FloatedForm);

document.addEventListener('DOMContentLoaded', function() {
  // Only run on scudetta products
  if (!window.location.pathname.includes('scudetta')) return;

  // Initialize stud conversion functionality
  initStudConversion();
});

function initStudConversion() {
  const softGroundBtn = document.getElementById('soft-ground-btn');
  const studModal = document.getElementById('stud-conversion-modal');
  const confirmBtn = document.getElementById('confirm-stud');
  const cancelBtn = document.getElementById('cancel-stud');
  const firmGroundBtn = document.querySelector('.surface-type:not(.product-surface-type-btn)');
  const addToBagButton = document.querySelector('product-form button[type="submit"]');

  // Stud conversion variant ID
  const STUD_CONVERSION_VARIANT_ID = 53995351703897;
  
  // Cache for stud conversion price by currency ISO code
  let studConversionPriceCache = {};
  
  // Supported currencies for price addition (ISO codes)
  const SUPPORTED_CURRENCY_CODES = ['USD', 'CAD', 'AUD', 'GBP', 'EUR'];
  
  // Cache for current currency ISO code
  let currentCurrencyCode = null;
  
  // Function to get current currency ISO code from Shopify
  async function getCurrentCurrencyCode() {
    // Return cached value if available
    if (currentCurrencyCode) {
      return currentCurrencyCode;
    }
    
    try {
      // Fetch cart to get currency ISO code
      const response = await fetch('/cart.js');
      if (response.ok) {
        const cartData = await response.json();
        if (cartData && cartData.currency) {
          currentCurrencyCode = cartData.currency;
          return currentCurrencyCode;
        }
      }
    } catch (e) {
      console.warn('Could not fetch currency code:', e);
    }
    
    // Fallback: try to get from meta tag or data attribute if available
    const currencyMeta = document.querySelector('meta[property="og:price:currency"]');
    if (currencyMeta) {
      currentCurrencyCode = currencyMeta.getAttribute('content');
      return currentCurrencyCode;
    }
    
    // Final fallback: return null (will prevent price update)
    return null;
  }
  
  // Helper function to check if currency is supported for price addition
  async function isCurrencySupportedForPriceUpdate() {
    const currencyCode = await getCurrentCurrencyCode();
    
    if (!currencyCode) {
      // If we can't determine currency, don't update price
      return false;
    }
    
    // Check if currency ISO code is in supported list
    return SUPPORTED_CURRENCY_CODES.includes(currencyCode);
  }

  // Set initial state
  if (firmGroundBtn) firmGroundBtn.classList.add('selected');
  if (softGroundBtn) softGroundBtn.classList.remove('selected');
  
  // Event listeners
  if (softGroundBtn) {
    softGroundBtn.addEventListener('click', async () => {
      // Update modal price before showing
      await updateModalPrice();
      studModal.style.display = 'block';
    });
  }

  if (firmGroundBtn) {
    firmGroundBtn.addEventListener('click', () => {
      firmGroundBtn.classList.add('selected');
      if (softGroundBtn) softGroundBtn.classList.remove('selected');
      updatePriceDisplay(false);
    });
  }

  if (addToBagButton) {
    addToBagButton.addEventListener('click', handleAddToBagClick);
  }

  if (studModal) {
    studModal.addEventListener('click', (e) => {
      if (e.target === studModal) {
        closeModal();
      }
    });
  }

  if (cancelBtn) {
    cancelBtn.addEventListener('click', closeModal);
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', handleConfirmClick);
  }

  // Initialize thumbnail gallery functionality
  initStudModalGallery();

  // Hook into variant changes to update price
  initVariantPriceHook();
  
  // Fetch stud conversion price on initialization
  updateModalPrice();

  // Helper functions
  function closeModal() {
    studModal.style.display = 'none';
    if (firmGroundBtn) firmGroundBtn.classList.add('selected');
    if (softGroundBtn) softGroundBtn.classList.remove('selected');
    updatePriceDisplay(false);
  }

  async function handleAddToBagClick(event) {
    // Only handle if soft ground is selected
    if (!softGroundBtn || !softGroundBtn.classList.contains('selected')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    
    await addProductsToCart();
  }

  async function handleConfirmClick() {
    studModal.style.display = 'none';
    
    // Update UI to show soft ground as selected
    if (softGroundBtn) softGroundBtn.classList.add('selected');
    if (firmGroundBtn) firmGroundBtn.classList.remove('selected');
    
    // Update price to include stud conversion cost
    await updatePriceDisplay(true);
  }

  // Function to fetch stud conversion variant price by ISO currency code
  async function getStudConversionPrice(currencyIsoCode) {
    // Return cached price if available
    if (studConversionPriceCache[currencyIsoCode]) {
      return studConversionPriceCache[currencyIsoCode];
    }

    // If we're already fetching for this currency, return the promise
    if (studConversionPriceCache[`${currencyIsoCode}_fetching`]) {
      return studConversionPriceCache[`${currencyIsoCode}_fetching`];
    }

    // Create promise to fetch price
    const fetchPromise = (async () => {
      try {
        // Method 1: Try Shopify's variant endpoint (most reliable)
        // This should return price in the customer's current currency for multi-currency stores
        const variantInfoUrl = `/variants/${STUD_CONVERSION_VARIANT_ID}.js`;
        
        let response = await fetch(variantInfoUrl);
        
        if (response.ok) {
          const variantData = await response.json();
          if (variantData && variantData.price) {
            // Price is in cents, convert to currency units
            const priceInCurrencyUnits = variantData.price / 100;
            studConversionPriceCache[currencyIsoCode] = priceInCurrencyUnits;
            delete studConversionPriceCache[`${currencyIsoCode}_fetching`];
            return priceInCurrencyUnits;
          }
        }

        // Method 2: Try to fetch from product page with variant parameter
        // Try common product handle variations
        const possibleHandles = ['stud-conversion', 'stud-conversion-service', 'stud-conversion-kit'];
        
        for (const handle of possibleHandles) {
          const productUrl = `/products/${handle}?variant=${STUD_CONVERSION_VARIANT_ID}&section_id=price`;
          
          try {
            response = await fetch(productUrl);
            if (response.ok) {
              const html = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              // Look for price in the response
              const priceElement = doc.querySelector('.price-item--regular, .price__regular, [data-price]');
              if (priceElement) {
                const priceText = priceElement.textContent.trim();
                const priceData = parsePrice(priceText);
                if (priceData) {
                  // Store by ISO code (we'll verify the currency matches)
                  studConversionPriceCache[currencyIsoCode] = priceData.amount;
                  delete studConversionPriceCache[`${currencyIsoCode}_fetching`];
                  return priceData.amount;
                }
              }
            }
          } catch (e) {
            // Continue to next handle
            continue;
          }
        }

        // Method 3: Try fetching price snippet directly
        const priceSnippetUrl = `/products/${possibleHandles[0]}?view=price&variant=${STUD_CONVERSION_VARIANT_ID}`;
        response = await fetch(priceSnippetUrl);
        
        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          const priceElement = doc.querySelector('.price-item--regular, .price__regular, [data-price]');
          if (priceElement) {
            const priceText = priceElement.textContent.trim();
            const priceData = parsePrice(priceText);
            if (priceData) {
              studConversionPriceCache[currencyIsoCode] = priceData.amount;
              delete studConversionPriceCache[`${currencyIsoCode}_fetching`];
              return priceData.amount;
            }
          }
        }
      } catch (e) {
        console.warn('Could not fetch stud conversion price:', e);
      }

      // Final fallback: return null (will prevent price change)
      delete studConversionPriceCache[`${currencyIsoCode}_fetching`];
      return null;
    })();

    // Store the promise while fetching
    studConversionPriceCache[`${currencyIsoCode}_fetching`] = fetchPromise;
    
    return fetchPromise;
  }

  // Function to update modal price display
  async function updateModalPrice() {
    const modalPriceElement = document.querySelector('.stud-modal__price');
    if (!modalPriceElement) return;

    // Get current currency ISO code
    const currencyIsoCode = await getCurrentCurrencyCode();
    if (!currencyIsoCode) {
      // Fallback to default if we can't determine currency
      modalPriceElement.textContent = '£24.99';
      return;
    }

    // Get current currency symbol from page for formatting
    const priceElements = document.querySelectorAll('.price-item--regular');
    if (priceElements.length === 0) {
      modalPriceElement.textContent = '£24.99';
      return;
    }

    const currentPriceText = priceElements[0].textContent;
    const priceData = parsePrice(currentPriceText);
    if (!priceData) {
      modalPriceElement.textContent = '£24.99';
      return;
    }

    // Fetch stud conversion price for current currency ISO code
    const studPrice = await getStudConversionPrice(currencyIsoCode);
    
    if (studPrice !== null) {
      // Format the price for display in modal using the currency symbol from the page
      const formattedPrice = formatPrice(studPrice, priceData.currency, currentPriceText, priceData.currencyFirst, priceData.usesCommaDecimal);
      modalPriceElement.textContent = formattedPrice;
    } else {
      // Fallback to default if fetch fails
      modalPriceElement.textContent = '£24.99';
    }
  }

  // Function to update price display based on soft ground selection
  async function updatePriceDisplay(isSoftGroundSelected) {
    const priceElements = document.querySelectorAll('.price-item--regular');
    
    if (priceElements.length === 0) return;
    
    // Get currency ISO code and check if it's supported
    const currencyIsoCode = await getCurrentCurrencyCode();
    const isSupported = await isCurrencySupportedForPriceUpdate();
    
    // Get currency symbol from first price element for formatting
    const firstPriceText = priceElements[0].getAttribute('data-original-price') || priceElements[0].textContent;
    const priceData = parsePrice(firstPriceText);
    
    if (!priceData) {
      // If we can't parse price, restore original
      priceElements.forEach(priceElement => {
        const originalText = priceElement.getAttribute('data-original-price') || priceElement.textContent;
        priceElement.textContent = originalText;
      });
      return;
    }
    
    // Fetch stud conversion price if needed and currency is supported
    let studConversionPrice = null;
    if (isSoftGroundSelected && isSupported && currencyIsoCode) {
      studConversionPrice = await getStudConversionPrice(currencyIsoCode);
    }
    
    priceElements.forEach(priceElement => {
      const originalText = priceElement.getAttribute('data-original-price') || priceElement.textContent;
      
      // Store original price if not already stored
      if (!priceElement.hasAttribute('data-original-price')) {
        priceElement.setAttribute('data-original-price', originalText);
      }
      
      // Only update price if soft ground is selected, price is fetched, and currency is supported
      if (isSoftGroundSelected && studConversionPrice !== null && isSupported) {
        // Parse the current price and add stud conversion cost
        const currentPriceData = parsePrice(originalText);
        if (currentPriceData) {
          const newPrice = currentPriceData.amount + studConversionPrice;
          const formattedPrice = formatPrice(newPrice, currentPriceData.currency, originalText, currentPriceData.currencyFirst, currentPriceData.usesCommaDecimal);
          priceElement.textContent = formattedPrice;
        } else {
          // If parsing fails, restore original
          priceElement.textContent = originalText;
        }
      } else {
        // Restore original price (either not selected, not supported, or price fetch failed)
        priceElement.textContent = originalText;
      }
    });
  }

  // Function to parse price from text
  function parsePrice(priceText) {
    const cleanText = priceText.trim();
    
    // Detect if comma is used as decimal separator (European format)
    // European format: €199,99 or 199,99 €
    // Non-European format: £199.99 or $199.99
    const hasCommaAsDecimal = /[£$€¥₹₽₩₪₦₨₱₲₴₵₸₺₼₾₿]\s*\d+,\d{2}\s*$|^\d+,\d{2}\s*[£$€¥₹₽₩₪₦₨₱₲₴₵₸₺₼₾₿]/.test(cleanText);
    const hasCommaAsThousands = /[£$€¥₹₽₩₪₦₨₱₲₴₵₸₺₼₾₿]\s*\d{1,3}(,\d{3})+\.\d{2}/.test(cleanText);
    
    let numericString = cleanText;
    
    // Remove currency symbols and spaces
    numericString = numericString.replace(/[£$€¥₹₽₩₪₦₨₱₲₴₵₸₺₼₾₿\s]/g, '');
    
    // Handle comma as decimal separator (European format)
    if (hasCommaAsDecimal && !hasCommaAsThousands) {
      // Replace comma with period for parsing
      numericString = numericString.replace(',', '.');
    } else if (hasCommaAsThousands) {
      // Remove thousands separators (commas before decimal point)
      numericString = numericString.replace(/,/g, '');
    } else {
      // Remove any remaining commas (might be thousands separators)
      // Only remove if there's a decimal point after
      const parts = numericString.split('.');
      if (parts.length === 2) {
        // Has decimal point, remove commas from integer part
        parts[0] = parts[0].replace(/,/g, '');
        numericString = parts.join('.');
      } else {
        // No decimal point, remove all commas
        numericString = numericString.replace(/,/g, '');
      }
    }
    
    const amount = parseFloat(numericString);
    
    if (isNaN(amount)) return null;
    
    // Check if currency comes first
    const currencyFirst = /^[£$€¥₹₽₩₪₦₨₱₲₴₵₸₺₼₾₿]/.test(cleanText);
    
    // Get currency symbol (default to £)
    const currencyMatch = cleanText.match(/[£$€¥₹₽₩₪₦₨₱₲₴₵₸₺₼₾₿]/);
    const currency = currencyMatch ? currencyMatch[0] : '£';
    
    return {
      amount: amount,
      currency: currency,
      originalFormat: priceText,
      currencyFirst: currencyFirst,
      usesCommaDecimal: hasCommaAsDecimal && !hasCommaAsThousands
    };
  }

  // Function to format price with proper currency formatting
  function formatPrice(price, currency, originalText, currencyFirst, usesCommaDecimal) {
    // Detect format from original text
    const hasCommas = originalText.includes(',');
    const hasSpaces = originalText.includes(' ');
    const hasDecimals = originalText.includes('.') || originalText.includes(',');
    
    let formattedPrice;
    
    // Determine if we should use European number formatting
    const isEuropeanCurrency = currency === '€' || currency === '₽' || currency === '₺';
    const shouldUseCommaDecimal = usesCommaDecimal || (isEuropeanCurrency && !hasCommas);
    
    if (shouldUseCommaDecimal) {
      // European format: use comma as decimal separator
      formattedPrice = price.toFixed(2).replace('.', ',');
    } else if (hasCommas && !shouldUseCommaDecimal) {
      // Use locale formatting for thousands separators (non-European with commas)
      formattedPrice = price.toLocaleString('en-GB', { 
        minimumFractionDigits: hasDecimals ? 2 : 0, 
        maximumFractionDigits: 2 
      });
    } else {
      formattedPrice = hasDecimals ? price.toFixed(2) : Math.round(price).toString();
    }
    
    if (currencyFirst) {
      return hasSpaces ? `${currency} ${formattedPrice}` : `${currency}${formattedPrice}`;
    } else {
      return hasSpaces ? `${formattedPrice} ${currency}` : `${formattedPrice}${currency}`;
    }
  }

  // Hook into variant changes to ensure price is updated correctly
  function initVariantPriceHook() {
    // Use MutationObserver to watch for price changes
    const priceObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Check if price elements were added or modified
          const priceElements = document.querySelectorAll('.price-item--regular');
          priceElements.forEach(element => {
            // If this is a new price element or the price changed, update it
            if (!element.hasAttribute('data-original-price')) {
              element.setAttribute('data-original-price', element.textContent);
              if (softGroundBtn && softGroundBtn.classList.contains('selected')) {
                updatePriceDisplay(true); // Fire and forget - async call
              }
            }
          });
        }
      });
    });

    // Start observing the price wrapper
    const priceWrapper = document.querySelector('.price-wrapper');
    if (priceWrapper) {
      priceObserver.observe(priceWrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Also listen for variant change events
    document.addEventListener('variant:change', function() {
      setTimeout(async () => {
        if (softGroundBtn && softGroundBtn.classList.contains('selected')) {
          await updatePriceDisplay(true);
          // Also update modal price in case currency changed
          await updateModalPrice();
        }
      }, 100);
    });

    // Listen for the shopify:section:load event to handle dynamic updates
    document.addEventListener('shopify:section:load', function() {
      setTimeout(async () => {
        if (softGroundBtn && softGroundBtn.classList.contains('selected')) {
          await updatePriceDisplay(true);
        }
        // Update modal price when section loads
        await updateModalPrice();
      }, 100);
    });

    // Initial price setup
    setTimeout(() => {
      const priceElements = document.querySelectorAll('.price-item--regular');
      priceElements.forEach(element => {
        if (!element.hasAttribute('data-original-price')) {
          element.setAttribute('data-original-price', element.textContent);
        }
      });
    }, 100);
  }

  async function addProductsToCart() {
    const productForm = document.querySelector('product-form');
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (!productForm || !cartDrawer) {
      return;
    }

    // Set loading state
    const submitButton = productForm.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }

    try {
      // Get current variant ID
      const variantInput = productForm.querySelector('input[name="id"]');
      const firmGroundVariantId = variantInput?.value;

      if (!firmGroundVariantId) {
        return;
      }

      // Get current variant information
      const variantRadios = document.querySelector('variant-radios');
      let currentVariant = null;
      
      if (variantRadios) {
        const variantData = JSON.parse(variantRadios.querySelector('[type="application/json"]').textContent);
        currentVariant = variantData.find(variant => variant.id == firmGroundVariantId);
      }

      // Get product metafields for colourway
      const productMetafieldElement = document.querySelector('.product_metafield');
      let colourway = '';
      if (productMetafieldElement) {
        const metafieldText = productMetafieldElement.textContent.trim();
        // Extract colourway from metafield text (format: "colourway, surface_type")
        const parts = metafieldText.split(',');
        if (parts.length > 0) {
          colourway = parts[0].trim();
        }
      }

      // Get size from current variant options
      let size = '';
      if (currentVariant && currentVariant.options) {
        // Find the size option (usually option2 or option3)
        // New format: "UK 9 / US 10 / EU 42" contains " / "
        // Old format: numbers like "9" or "9.5", or size strings like "S (4-6.5UK)"
        for (let i = 0; i < currentVariant.options.length; i++) {
          const option = currentVariant.options[i];
          if (option) {
            // Check if it's the new international format
            if (option.includes(' / ')) {
              size = option;
              break;
            }
            // Check if it's an old format (number or size string)
            if (option.match(/^\d+(\.\d+)?$/) || 
                option.includes('UK)') || 
                option.match(/^[SML]\s*\(/)) {
              size = option;
              break;
            }
          }
        }
      }

      // Prepare cart data with properties for stud conversion
      const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      cartDrawer.setActiveElement(document.activeElement);

      const cartData = {
        items: [
          { id: firmGroundVariantId, quantity: 1 },
          { 
            id: 53995351703897, 
            quantity: 1,
            properties: {
              '_linked_boot_size': size,
              '_linked_boot_colourway': colourway,
              '_linked_boot_variant_id': firmGroundVariantId
            }
          }
        ],
        sections: sections,
        sections_url: window.location.pathname
      };

      // Debug logging

      // Add to cart
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';

      const response = await fetch(window.routes.cart_add_url, {
        ...config,
        body: JSON.stringify(cartData)
      });

      const result = await response.json();

      if (result.status) {
        return;
      }

      // Publish cart update event for other components (like new-nav cart count)
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'stud-conversion',
          productVariantId: firmGroundVariantId
        });
      }

      // Open cart drawer
      cartDrawer.renderContents(result);

      // Update stud conversion product titles in cart
      setTimeout(() => {
        updateStudConversionTitles();
      }, 100);

    } catch (error) {
      // Silent error handling for production
    } finally {
      // Reset button state
      if (submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      }
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
    }
  }

  // Function to update stud conversion product titles in cart
  function updateStudConversionTitles() {
    const cartItems = document.querySelectorAll('.cart-item');
    
    cartItems.forEach(item => {
      const titleElement = item.querySelector('.cart-item__name span');
      const quantityInput = item.querySelector('input[name="updates[]"]');
      
      if (titleElement && quantityInput) {
        // Get the variant ID from the cart item data or URL
        const cartItemId = quantityInput.getAttribute('data-index');
        const cartItemElement = document.getElementById(`CartDrawer-Item-${cartItemId}`) || 
                               document.getElementById(`CartItem-${cartItemId}`);
        
        if (cartItemElement) {
          // Check if this is the stud conversion product by looking for the variant ID
          // We can identify it by checking if the product title contains certain keywords
          const currentTitle = titleElement.textContent.trim();
          if (currentTitle.includes('Stud Conversion') || currentTitle.includes('stud conversion')) {
            titleElement.textContent = 'Stud Conversion - Non-refundable';
          }
        }
      }
    });
  }

  // Listen for cart updates to ensure titles are always correct
  document.addEventListener('cart:updated', function() {
    setTimeout(() => {
      updateStudConversionTitles();
    }, 100);
  });

  // Also listen for cart drawer opening
  document.addEventListener('cart-drawer:opened', function() {
    setTimeout(() => {
      updateStudConversionTitles();
    }, 100);
  });

  // Initialize stud modal gallery functionality
  function initStudModalGallery() {
    const thumbnails = document.querySelectorAll('.stud-modal__thumb');
    const mainImage = document.querySelector('.stud-modal__main-image img');

    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        // Remove active class from all thumbnails
        thumbnails.forEach(t => t.classList.remove('active'));
        
        // Add active class to clicked thumbnail
        thumb.classList.add('active');
        
        // Update main image
        const newImageSrc = thumb.getAttribute('data-image');
        if (newImageSrc) {
          mainImage.src = newImageSrc;
        }
      });
    });
  }
}
